import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../environment/environment';
import { Amplify,Auth } from 'aws-amplify';
import { AuthService } from '../../services/auth.service';
import { AuthGuard } from '../../services/guards/auth.guard';
import { Router } from '@angular/router';
import { fallIn, moveIn } from '../../router.animations';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { User } from '../../models/user';
import { Alert } from '../../common/alert/alert';

@Component({
  selector: 'ozm-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [moveIn(), fallIn()],
  host: { '[@moveIn]': '' }
})

export class LoginComponent implements OnInit, OnDestroy{
  UserForm: FormGroup;
  user: User = new User
  res_data: any;
  user_data: any;
  msg='';
  submitted: boolean = false;
  _alertMessage: Alert;
  
  constructor(
    private _authService: AuthService,
    private _authguard: AuthGuard,
    private _router: Router,
  ) {}
  // public signup(){
  //   Auth.federatedSignIn();
  // }
  // public signin(){
  //   Auth.federatedSignIn();
  // }

  ngOnInit(){
    if(this._authService.accessToken) {
      this._router.navigate([""]);
    }
    
    this.createForm();
  }

  ngOnDestroy(): void {

  }


  async signInNew(username: string, password: string) {
    try {
      // Sign in the user
      // const user = await Auth.signIn(username, password);
      const userCreds = await this._authService.signIn(username,password )
      console.log('User signed in:', userCreds);

      

      //retrieve and store access token
      // const session = await Auth.currentSession();
      const session = await this._authService.getCurrentSession();
      if (session && session.getAccessToken() && session.getIdToken()) {
      const accessToken = session.getAccessToken().getJwtToken();
      const idToken = session.getIdToken().getJwtToken();

      this._authService.idToken = idToken;
      this._authService.accessToken = accessToken;

      console.log('IdToken: \n' + this._authService.idToken);
      console.log('AccessToken: \n' + this._authService.accessToken);
      
      // Notify auth service about login to update app counts
      this._authService.notifyLogin();
      } else {
        console.log('Error: Session or token information is not available');
      }
      // Redirect to the home page (adjust the route as needed)
      this._router.navigate(['']);
    } catch (error) {
      console.log('Error signing in', error);
      this.msg = error.message;
    }
  }

  createForm() {
    this.UserForm = new FormGroup({
      phone: new FormControl(this.user.email, [
        Validators.required
      ]),

      pass: new FormControl(this.user.pass, [
        Validators.required
      ])
    });
  }

  isUserLoggedIn() {
    // return true
    if (!this._authService.isTokenExpired) {
      return true;
    } else {
      return false;
    }
  }

  private _displayAlert(message: string) {

  }

}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
 

  //Not using now - This is using cognito hosted ui authentication
  // public signInNew2() {
  //   try {
  //     Auth.federatedSignIn();
  //   } catch (error) {
  //     console.log('Error signing in:', error);
  //   }
  // }